module.exports = __webpack_public_path__ + "img/ico-order-active.4920acf1.svg";